import type { Simulation as SimulationType } from '@festina/life-general-types/life'
import { type Loadable, typeUtils } from '@festina-life/core'
import { CircularSpinner } from '@festina-life/ui/feedback'
import type { ComponentType } from 'react'

import type { CommandDataSimulationProps } from './CommandDataFormAndSimulation'
import type { AnyCommandVersion } from './types'

type Props<
  T extends SimulationType,
  C extends AnyCommandVersion['commandData'],
> = {
  commandSimulation: ComponentType<CommandDataSimulationProps<T, C>>
  simulation: Loadable<T>
  commandData: C
} & Pick<CommandDataSimulationProps<T, C>, 'simulationType'>

export const Simulation = <
  T extends SimulationType,
  C extends AnyCommandVersion['commandData'],
>({
  commandSimulation: CommandSimulation,
  simulation,
  commandData,
  simulationType,
}: Props<T, C>) => {
  if (typeUtils.isLoading(simulation)) {
    return (
      <div className="flex h-full items-center justify-center">
        <CircularSpinner />
      </div>
    )
  }

  if (typeUtils.isError(simulation) || !simulation) {
    return null
  }

  return (
    <CommandSimulation
      simulationType={simulationType}
      simulation={simulation}
      commandData={commandData}
    />
  )
}
